import { LogInfo } from '../pages/Log/Home'
import { ListReturn } from '../utils/maks'
import { AccountApiData, parseAccount } from './account'
import { BranchApiData, parseBranch } from './branch'
import { CashierApiData } from './cashier'
import { post } from './generic'

export interface LogApiData {
    id_log: number
    id_usuario: number
    id_caixa: number
    id_filial: number
    data: string
    hora: string
    flag_horario_verao: number
    acao: string
    modulo: string
    descricao: string | null
    requisicao: string
    usuario: AccountApiData
    caixa: CashierApiData
    filial: BranchApiData | null
}

export interface ListLogsInterface {
    skip: number
    take: number
    search?: string
    acao?: string[]
    modulo?: string[]
    id_usuario?: number[]
    id_caixa?: number[]
    id_filial?: number[]
    data_inicial?: string
    data_final?: string
}

export function parseLog(data: LogApiData): LogInfo {
    return {
        id: data.id_log,
        date: data.data,
        hour: data.hora,
        isSummerTime: !!data.flag_horario_verao,
        action: data.acao,
        module: data.modulo,
        description: data.descricao,
        requisition: data.requisicao,
        cashier: {
            id: data.caixa?.id_caixa ?? 0,
            hash: '',
            name: data.caixa?.nome ?? '',
            isActive: false,
            branch: null,
        },
        account: {
            id: 0,
            name: data.usuario?.nome ?? '',
            username: '',
            password: '',
            cpassword: '',
            rules: [],
            isMaster: false,
            isActive: false,
            loginWithImage: false,
            image: null,
            branch: null,
        },
        branch: data.filial ? parseBranch(data.filial) : null,
    }
}

export async function listLogs(
    data: ListLogsInterface
): Promise<ListReturn<LogInfo>> {
    const res = await post('log/list', data)
    return {
        data: res.data.data.data.map((l: LogApiData) =>
            parseLog(l)
        ),
        count: res.data.data.count,
    }
}